import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import LogoMain from "../../../assets/images/altruist_logo.png";
import { AppContext } from "../../../context/AppContext";
import { resetPassword } from "../../../api/Api";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../../utils/common-utils";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { userId } = useParams(); // Get userId from URL parameter
  const [inputData, setInputData] = useState({
    pwd: "",
    conPwd: "",
  });
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

  // Redirect if no userId is present
  useEffect(() => {
    if (!userId) {
      navigate('/');
    }
  }, [userId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { pwd, conPwd } = inputData;
    if (
      !pwd ||
      (pwd && !pass.test(pwd)) ||
      !conPwd ||
      (conPwd && conPwd !== pwd)
    ) {
      setError(true);
    } else {
      setLoader(true);
      let payload = {
        newPassword: pwd,
        confirmPassword: conPwd,
        uid: userId,
      };
      try {
        const response = await resetPassword(payload);
        console.log("response", response);
        if (response?.statusDescription?.status === 200) {
          Swal.fire({
            text: response.statusDescription.description || "Password has been changed successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/");
          });
        } else {
          Swal.fire({
            text: response?.statusDescription?.description || "Failed to reset password",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <div className="bg_image align-items-left min-vh-100">
      <div className="container my-auto">
        <div className="login-box">
          <div className="login-logo">
            <img src={LogoMain} alt="logo" width="123px" />
          </div>
          <div className="login-box-body">
            <p className="login-box-msg mb-3">Reset your password</p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group has-feedback">
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control ${
                      error && (!inputData.pwd || !pass.test(inputData.pwd)) ? "is-invalid" : ""
                    }`}
                    placeholder="New Password"
                    value={inputData.pwd}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        pwd: e.target.value,
                      })
                    }
                    autoComplete="new-password"
                    required
                  />
                  <span
                    className="input-group-text"
                    id="basic-addon2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`fa fa-${!showPassword ? "eye-slash" : "eye"}`}
                    ></i>
                  </span>
                </div>

                {error &&
                  (!inputData.pwd ||
                    (inputData.pwd && !pass.test(inputData.pwd))) && (
                    <div className="invalid-feedback d-block error">
                      {!inputData.pwd
                        ? "Please enter a password"
                        : inputData.pwd && !pass.test(inputData.pwd)
                        ? "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character"
                        : ""}
                    </div>
                  )}
              </div>
              <div className="form-group has-feedback">
                <div className="input-group">
                  <input
                    type={showPassword1 ? "text" : "password"}
                    className={`form-control ${
                      error && (!inputData.conPwd || inputData.conPwd !== inputData.pwd) ? "is-invalid" : ""
                    }`}
                    placeholder="Confirm Password"
                    value={inputData.conPwd}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        conPwd: e.target.value,
                      })
                    }
                    autoComplete="new-password"
                    required
                  />
                  <span
                    className="input-group-text"
                    id="basic-addon2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword1(!showPassword1)}
                  >
                    <i
                      className={`fa fa-${
                        !showPassword1 ? "eye-slash" : "eye"
                      }`}
                    ></i>
                  </span>
                </div>

                {error &&
                  (!inputData.conPwd ||
                    (inputData.conPwd &&
                      inputData.conPwd !== inputData.pwd)) && (
                    <div className="invalid-feedback d-block error">
                      {!inputData.conPwd
                        ? "Please enter a password"
                        : inputData.conPwd && inputData.conPwd !== inputData.pwd
                        ? "Password does not match"
                        : ""}
                    </div>
                  )}
              </div>

              <div className="d-flex justify-content-between">
                
                <button
                  type="button"
                  className="btn btn-dark btn-custom-width"
                  onClick={() => navigate("/")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-custom-bg btn-custom-width"
                  disabled={loader}
                >
                  Reset
                  {loader && <i className="fa fa-spinner fa-spin ms-2"></i>}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
